var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 33,
    viewBox: "0 0 97 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3669",
    "data-name": "Group 3669",
    transform: "translate(-651 -620)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3668",
    "data-name": "Group 3668",
    transform: "translate(585.508 391.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3065",
    "data-name": "Path 3065",
    d: "M72.3,228.012l2.1,4.265,4.707.684-3.406,3.32.8,4.688-4.21-2.213-4.21,2.213.8-4.688-3.406-3.32,4.707-.684Z",
    fill: "#fbbd04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3066",
    "data-name": "Path 3066",
    d: "M127.7,228.012l2.1,4.265,4.707.684-3.406,3.32.8,4.688-4.21-2.213-4.21,2.213.8-4.688-3.406-3.32,4.707-.684Z",
    transform: "translate(-40.3)",
    fill: "#fbbd04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3067",
    "data-name": "Path 3067",
    d: "M183.091,228.012l2.1,4.265,4.707.684-3.406,3.32.8,4.688-4.21-2.213-4.21,2.213.8-4.688-3.406-3.32,4.707-.684Z",
    transform: "translate(-80.599)",
    fill: "#fbbd04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3068",
    "data-name": "Path 3068",
    d: "M238.485,228.012l2.1,4.265,4.707.684-3.406,3.32.8,4.688-4.21-2.213-4.21,2.213.8-4.688-3.406-3.32,4.707-.684Z",
    transform: "translate(-120.899)",
    fill: "#fbbd04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3069",
    "data-name": "Path 3069",
    d: "M293.879,228.012l2.1,4.265,4.707.684-3.406,3.32.8,4.688-4.21-2.213-4.21,2.213.8-4.688-3.406-3.32,4.707-.684Z",
    transform: "translate(-161.198)",
    fill: "#fbbd04"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Google_Reviews",
    "data-name": "Google Reviews",
    transform: "translate(651 650)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Google Reviews")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewsLogo);
export default __webpack_public_path__ + "static/media/reviewsLogo.3fb121f7.svg";
export { ForwardRef as ReactComponent };